import React from 'react';
import {Link} from 'react-router-dom';
import AurStepperTab from '../../../common/aur-stepper-tab/AurStepperTab';

const StepperTab: React.FC = () => {
  const setActiveStepClickHandler = () => {
    alert('Step clicked');
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Stepper Tab</h1>
        <div>
          Steppers convey progress through numbered steps. It provides a
          wizard-like workflow.
        </div>

        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurStepperTab
            steps={[{label:'Step 1'}, {label:'Step 2'}, {label:'Step 3'}, {label:'Step 4'}]}
            activeStep={1}
            setActiveStep={setActiveStepClickHandler}
          />
        </div>
      </div>
    </>
  );
};

export default StepperTab;
